import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=0690228d&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=0690228d&prod&scoped=true&lang=css&"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=0690228d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0690228d",
  null
  
)

export default component.exports